import { Injectable } from '@angular/core';
import { RestApiService, PaginatedResponse } from './rest-api.service';
import { Observable } from 'rxjs';
import { Site } from '../models/base.model';
import { SiteFields } from 'app/app.config';

@Injectable({
  providedIn: 'root'
})
export class ApiSiteService extends RestApiService {

  /**
   * Get paginated list of sites
   * Automatically adds default SiteFields if not specified
   */
  public apiGetObjects(params: any = {}): Observable<PaginatedResponse<Site>> {
    if (!params['fields']) {
      params['fields'] = SiteFields;
    }
    return this.getList('project-sites/', Site.parse, params);
  }

  /**
   * Get a single site by ID
   * Automatically adds default SiteFields if not specified
   */
  public apiGetObject(id: any, params: any = {}): Observable<Site> {
    if (!params['fields']) {
      params['fields'] = SiteFields;
    }
    return this.getSingle(`project-sites/${id}/`, Site.parse, params);
  }

  /**
   * Create a new site
   * Automatically adds default SiteFields if not specified
   */
  public apiPostObject(payload: any, params: any): Observable<Site> {
    if (!params['fields']) {
      params['fields'] = SiteFields;
    }
    return this.postSingle('project-sites/', payload, Site.parse, params);
  }

  /**
   * Update an existing site
   * Automatically adds default SiteFields if not specified
   */
  public apiPutObject(id: number, payload: any, params: any): Observable<Site> {
    if (!params['fields']) {
      params['fields'] = SiteFields;
    }
    return this.putSingle(`project-sites/${id}/`, payload, Site.parse, params);
  }

  /**
   * Delete a site
   */
  public apiDeleteObject(id: any, params: any): Observable<any> {
    return this.deleteSingle(`project-sites/${id}/`, params);
  }

  /**
   * Get service status for a site (raw response, no parsing)
   */
  public apiGetServiceStatus(id: any, params: any = {}): Observable<any> {
    return this.getRaw(`project-sites/${id}/service-status/`, params);
  }

}
